import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { addJobDepartment, deleteJobDepartment, fetchJobDepartments, updateJobDepartment } from "./JobDepartmentAPI";

const initialState = {
  data: [],
  loading: false,
  error: null,
};

export const fetchJobDepartmentsAsync = createAsyncThunk(
  "jobDepartments/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const data = await fetchJobDepartments();

      const resp = data.response;
      // console.log("data's response", data.response)
      return resp;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


export const deleteJobDepartmentAsync = createAsyncThunk(
  'jobDepartments/delete',
  async (uuid, { rejectWithValue }) => {
    try {
      await deleteJobDepartment(uuid);
      return uuid; 
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateJobDepartmentAsync = createAsyncThunk(
  'jobDepartments/update',
  async ({ uuid, jobDepartmentData }, { rejectWithValue }) => {
    try {
      const response = await updateJobDepartment(uuid, jobDepartmentData);
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const addJobDepartmentAsync = createAsyncThunk(
  "jobDepartments/add",
  async (newJobDepartment) => {
    try {
      const data = await addJobDepartment(newJobDepartment);
      return data;
    } catch (error) {
      return error
      // return rejectWithValue(error.message);
    }
  }
);

const jobDepartmentsSlice = createSlice({
  name: "jobDepartments",
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchJobDepartmentsAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchJobDepartmentsAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.error = null;
      })
      .addCase(fetchJobDepartmentsAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      })
      
      .addCase(addJobDepartmentAsync.fulfilled, (state, action) => {
        state.data?.push(action.payload);
      })
      .addCase(addJobDepartmentAsync.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(updateJobDepartmentAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateJobDepartmentAsync.fulfilled, (state, action) => {
        state.loading = false;
        if (!state.data) {
          state.data = [];
        }
        state.data = state.data.map((jobTitle) =>
          jobTitle.uuid === action.payload.uuid ? action.payload : jobTitle
        );
      })
      .addCase(updateJobDepartmentAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      
      .addCase(deleteJobDepartmentAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteJobDepartmentAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = state.data.filter((title) => title.uuid !== action.payload);
      })
      .addCase(deleteJobDepartmentAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});
export const selectJobDepartments = (state) => state.jobDepartments.data;

export default jobDepartmentsSlice.reducer;
